import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale, mq } from '@/theme';

export const useMetricsFilterBarStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: tokens.spacingHorizontalL,
    padding: tokens.spacingVerticalL,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground2,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    [mq.smallTablet]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    minWidth: '12rem',
    [mq.smallTablet]: {
      minWidth: 0,
      width: '100%',
    },
  },
  periodGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    [mq.smallTablet]: {
      width: '100%',
    },
  },
  periodLabel: {
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2,
  },
  dateRow: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    alignItems: 'flex-end',
    [mq.smallTablet]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  actions: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    alignItems: 'flex-end',
    [mq.smallTablet]: {
      width: '100%',
    },
  },
});
